import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Text } from '@soluto-private/mx-asurion-ui-react';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';

import {
  SectionContainer,
  SectionList,
  SectionListItem,
  SectionTitle,
} from '../components';

const TEXT = TranslationEntries.Repairs.Cart.About;

export const AboutOurRepairsSection: FC = () => {
  const { t } = useTranslation();

  return (
    <SectionContainer skeletonHeight="164px">
      <SectionTitle>{t(TEXT.Title)}</SectionTitle>
      <SectionList>
        {[
          t(TEXT.ValueProp1),
          t(TEXT.ValueProp2),
          t(TEXT.ValueProp3),
          t(TEXT.ValueProp4),
        ].map((text) => (
          <SectionListItem key={text}>
            <Icon size="medium" src="checkmark-v" />
            <Text>{text}</Text>
          </SectionListItem>
        ))}
      </SectionList>
    </SectionContainer>
  );
};
